import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import messages from '../../i18n/base-en';
import provincesList from '../../utils/list-options/provinces';
import statesList from '../../utils/list-options/states';
import { InputText } from '../../components/reusables';
import { postAffiliateBeneficiary, putAffiliateBeneficiary } from '../../actions/affiliate-beneficiary-actions';
import validate from '../../pages/profile/validateCompanyForm';
import { Gtm } from '../../utils/gtm';
import ActionMessageHelper, { BILLING_INFOS_SUCCESS } from '../../utils/ActionMessageHelper';
import { useConfirmationOnFields } from '../reusables/useConfirmationOnFields';
import { withRouter } from 'react-router';
import { getCountryLabelDefaultMessage } from '../../utils/list-options/countries';
import _ from 'lodash';
import 'materialize-css';
import { Select } from 'react-materialize';
import { useState } from 'react';
const PersonBeneficiary = ({
  beneficiaryInfos,
  fields,
  fields: { name, city, province, state, region, country, postalCode, address1, address2, address3, address4, address5 },
  dispatch,
  invalid,
  parentRoute,
  router,
  submitRef,
}) => {
  const [currentBeneficiaryValues, setCurrentBeneficiaryValues] = useState(fields._meta.values);
  const getSubdivisionValue = () => {
    switch (country.value) {
      case 'CA':
        return province.value;
      case 'US':
        return state.value;
      default:
        return region.value;
    }
  };

  const handleSubmitPerson = () => {
    const affiliateBeneficiary = {
      name: name.initialValue,
      country_code: country.initialValue,
      subdivision: getSubdivisionValue(),
      postal_code: postalCode.value || null,
      city: city.value || null,
      address_line1: address1.value,
      address_line2: address2.value || null,
      address_line3: address3.value || null,
      address_line4: address4.value || null,
      address_line5: address5.value || null,
    };

    if (!beneficiaryInfos) {
      dispatch(postAffiliateBeneficiary(affiliateBeneficiary)).then(() => {
        ActionMessageHelper.showSuccess(dispatch, BILLING_INFOS_SUCCESS);
      });
    } else {
      dispatch(putAffiliateBeneficiary(affiliateBeneficiary)).then(() => {
        ActionMessageHelper.showSuccess(dispatch, BILLING_INFOS_SUCCESS);
      });
    }

    Gtm.event('profile - billing information', 'Click', `Save changes - Beneficiary`);
  };

  const watchedItems = {
    city,
    province,
    state,
    region,
    postalCode,
    address1,
    address2,
    address3,
    address4,
    address5,
  };

  useConfirmationOnFields({
    router,
    route: parentRoute,
    items: watchedItems,
    alertMessage: messages.profileSettingsUnsavedChecked.description,
  });

  const countryLabelDefaultMessage = getCountryLabelDefaultMessage(country.initialValue);
  country.value = countryLabelDefaultMessage;

  return (
    <div className="company-validate">
      <div className="beneficiary-input">
        <InputText disabled field={name} id="name" label={messages.genericTextName} labelClasses="" type="text" />
      </div>
      <div className="beneficiary-input">
        <InputText
          disabled
          displayErrorInstantly
          field={country}
          id="country-id"
          label={messages.genericTextCountry}
          labelClasses=""
          type="text"
        />
      </div>
      {country.initialValue === 'CA' && (
        <div className="beneficiary-input">
          <Select
            id="identity-province"
            label={messages.genericTextProvince.description}
            onChange={province.onChange}
            tabIndex={131}
            value={province.value || ''}
          >
            <option disabled value="">
              Choose
            </option>
            {provincesList.map((province, index) => (
              <option key={province.name + '-' + index} value={province.value}>
                {province.label.defaultMessage}
              </option>
            ))}
          </Select>
        </div>
      )}
      {country.initialValue === 'US' && (
        <div className="beneficiary-input">
          <Select
            id="identity-state"
            label={messages.genericTextProvince.description}
            onChange={state.onChange}
            tabIndex={131}
            value={state.value || ''}
          >
            <option disabled value="">
              Choose
            </option>
            {statesList.map((state, index) => (
              <option key={state.name + '-' + index} value={state.value}>
                {state.label.defaultMessage}
              </option>
            ))}
          </Select>
        </div>
      )}
      {country.initialValue !== 'CA' && country.initialValue !== 'US' && (
        <div className="row">
          <InputText
            className="col-md-12"
            displayErrorInstantly
            field={region}
            id="region"
            label={messages.genericTextRegion}
            tabIndex={160}
            type="text"
          />
        </div>
      )}
      <div className="beneficiary-input">
        <InputText
          displayErrorInstantly
          field={address1}
          id="address1-id"
          label={{
            ...messages.genericTextAddress,
            defaultMessage: 'Address Line 1',
          }}
          labelClasses=""
          type="text"
        />
      </div>
      <div className="beneficiary-input">
        <InputText
          displayErrorInstantly
          field={address2}
          id="address2-id"
          label={{
            ...messages.genericTextAddress,
            defaultMessage: 'Address Line 2',
          }}
          labelClasses=""
          type="text"
        />
      </div>
      <div className="beneficiary-input" style={{ display: address2.value ? 'block' : 'none' }}>
        <InputText
          displayErrorInstantly
          field={address3}
          id="address3-id"
          label={{
            ...messages.genericTextAddress,
            defaultMessage: 'Address Line 3',
          }}
          labelClasses=""
          type="text"
        />
      </div>
      <div className="beneficiary-input" style={{ display: address3.value ? 'block' : 'none' }}>
        <InputText
          displayErrorInstantly
          field={address4}
          id="address4-id"
          label={{
            ...messages.genericTextAddress,
            defaultMessage: 'Address Line 4',
          }}
          labelClasses=""
          type="text"
        />
      </div>
      <div className="beneficiary-input" style={{ display: address4.value ? 'block' : 'none' }}>
        <InputText
          displayErrorInstantly
          field={address5}
          id="address5-id"
          label={{
            ...messages.genericTextAddress,
            defaultMessage: 'Address Line 5',
          }}
          labelClasses=""
          type="text"
        />
      </div>
      <div className="beneficiary-input">
        <InputText
          displayErrorInstantly
          field={postalCode}
          id="postalCode-id"
          label={messages.genericTextZipCode}
          labelClasses=""
          type="text"
        />
      </div>
      <div className="beneficiary-input">
        <InputText displayErrorInstantly field={city} id="city-id" label={messages.genericTextCity} labelClasses="" type="text" />
      </div>
      <div className="form-buttons">
        <button
          className="waves-effect waves-light btn bg-primary-color"
          disabled={invalid || _.isEqual(currentBeneficiaryValues, fields._meta.values)}
          onClick={() => {
            handleSubmitPerson();
            setCurrentBeneficiaryValues(fields._meta.values);
          }}
          ref={submitRef}
        >
          Save changes
        </button>
      </div>
    </div>
  );
};

export default connect((state) => ({
  beneficiaryInfos: state.profile.data?.affiliateBeneficiary,
  accountType: state.profile.data.customProfile.affiliate.affiliate_type?.type,
  affCompany: state.profile?.data?.affCompany,
}))(
  withRouter(
    reduxForm(
      {
        form: 'personBeneficiaryInfos',
        touchOnChange: false,
        touchOnBlur: false,
        fields: [
          'name',
          'country',
          'province',
          'state',
          'region',
          'city',
          'address1',
          'address2',
          'address3',
          'address4',
          'address5',
          'postalCode',
        ],
        validate,
      },
      (state) => ({
        initialValues: {
          name: state.profile.data.affiliateBeneficiary?.name,
          country: state.profile.data.affiliateBeneficiary?.country_code,
          state: state.profile.data.affiliateBeneficiary?.subdivision,
          province: state.profile.data.affiliateBeneficiary?.subdivision,
          region: state.profile.data.affiliateBeneficiary?.subdivision,
          address1: state.profile.data.affiliateBeneficiary?.address_line1 || '',
          address2: state.profile.data.affiliateBeneficiary?.address_line2 || '',
          address3: state.profile.data.affiliateBeneficiary?.address_line3 || '',
          address4: state.profile.data.affiliateBeneficiary?.address_line4 || '',
          address5: state.profile.data.affiliateBeneficiary?.address_line5 || '',
          postalCode: state.profile.data.affiliateBeneficiary?.postal_code || '',
          city: state.profile.data.affiliateBeneficiary?.city || '',
        },
      })
    )(PersonBeneficiary)
  )
);
